export const titleSmallPlaceholder = {
    value: "Lorem ipsum",
    color: "text-site-500",
};
export const titlePlaceholder = {
    value: "Lorem ipsum",
    color: "text-gray-900",
};
export const textPlaceHolder = {
    value: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    color: "text-gray-900",
};
export const imagePlaceholder = {
    file: "placeholder.png",
    src: "https://placehold.co/400",
    placeholder: true,
    alt: "Afbeelding",
    type: "image",
};
export const renderHtmlImageProps = {
    "editor-img-file": imagePlaceholder.file,
    "editor-img-placeholder": imagePlaceholder.placeholder.toString(),
};
export const bgPlaceholder = {
    color: "bg-white",
};
export const renderHtmlLinkProps = {
    href: "#",
    target: "_self",
    "editor-link-type": "link",
};
//# sourceMappingURL=placeholders.js.map